<!--
- 购买信息确认（手机端）
- author: lzp
- greatTime: 2019-11-06
-->
<template lang="html">
  <div class="buyinfo-container" :style="{'height': window_height+'px'}">
    <div class="logo-div">
      <img :src="user.wx_avatarurl" v-if="user.wx_avatarurl">
      <i class="iconfont" v-else>&#xe65b;</i>
      <p>{{user.name?user.name:user.wx_nickname}}</p>
    </div>
    <div class="info-content">
      <p class="info-item"> <span>开通账号</span> <span>{{user.mobile}}</span> </p>
      <p class="info-item"> <span>购买服务</span> <span>{{detail.title}}</span> </p>
      <p class="info-item"> <span>到期时间</span> <span>{{getTime(detail.create_time)}}</span> </p>
      <!-- <p class="info-item"> <span>折扣优惠</span> <span>无</span> </p> -->
      <p class="info-item"> <span>支付方式</span> <span>微信支付</span> </p>
      <p class="info-item"> <span>实际付款</span> <span>￥{{detail.pay_total}}/年</span> </p>
    </div>
    <div class="button" @click="sure">
      立即购买
    </div>
  </div>
</template>

<script>
import { orderDetail, createThemeTypePayUrl } from '../service'
import { user_mixin } from 'mobile/js/user_mixin'
import moment from 'moment'
export default {
  mixins: [user_mixin],
  data() {
    return {
      detail: '',
      pay_url: ''
    }
  },
  computed: {
    window_height() {
      return document.documentElement.clientHeight
    }
  },
  methods: {
    async orderDetail() {
      let res = await orderDetail({
        user_key: this.$store.state.user_key,
        uid: this.$route.params.order_uid,
        type: this.$route.params.type
      })
      if (res.status == 'success') {
        this.detail = res.res[0]
        this.createThemeTypePayUrl()
      } else {
        this.$Message.error(res.message)
      }
    },
    async createThemeTypePayUrl() {
      let res = await createThemeTypePayUrl({
        user_key: this.$store.state.user_key,
        uid: this.$route.params.order_uid,
        is_mobile: 1,
        backurl: Buffer.from(window.location.protocol + '//' + window.location.host + '/mindex/ok?name='+this.detail.title+'&url='+this.$route.query.url).toString('base64')
      })
      if (res.status == 'success') {
        this.pay_url = res.url
      } else {
        this.$Message.error(res.message)
      }
    },
    sure() {
      location.replace(this.pay_url)
    },
    getTime(time) {
      return moment(time).add(1, 'years').format('YYYY-MM-DD')
    }
  },
  created() {
    this.orderDetail()
  }
}
</script>

<style lang="stylus" scoped>
.buyinfo-container
  background-color: #F8F8F8;
  padding-top: .2rem;
  .logo-div
    height: 1.4rem;
    padding: 0 .4rem;
    display: flex;
    align-items: center;
    margin-bottom: .2rem;
    background-color: #ffffff
    img
      width: 1rem;
      height: 1rem;
    i
      font-size: 1rem;
    p
      margin-left: .32rem;
      font-size: .28rem;
      color: #333333;
  .info-content
    background-color: #FFFFFF;
    padding: 0 .3rem;
    p
      height: 1rem;
      line-height: 1rem;
      font-size: .28rem;
      span:nth-child(1)
        color: #666666
      span:nth-child(2)
        color: #333333
        margin-left: .3rem;
    p+p
      border-top: 1px solid #DFDFDF;
  .button
    margin: .6rem auto 0;
    width: 6rem;
    height: .9rem;
    color: #ffffff;
    font-size: .36rem;
    text-align: center;
    line-height: .9rem;
    border-radius: .45rem;
    background: rgba(250, 122, 80, 1)
</style>
